import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-6" }
const _hoisted_2 = { class: "flex flex-row space-x-4" }
const _hoisted_3 = ["disabled", "checked"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Action required.", -1)

import { computed, onMounted, PropType, ref, watch } from 'vue';
import { BaseTextInput } from '@/lib/components/Input';
import { BaseButton } from '@/lib/components/Button';
import PatientSupportingDocumentModal from '@/views/patient/PatientSupportingDocumentModal.vue';
import { i18n } from '@/i18n/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckListItem',
  props: {
  checkboxClass: {
    type: String,
    default: 'text-primary-500 h-4 w-4'
  },
  actionMessage: {
    type: String,
    default() {
      return i18n.global.t('custom.uhb.scans.list-item-message');
    }
  },
  label: {
    type: String,
    default: ''
  },
  modelValue: {
    type: Array as PropType<Array<boolean | string>>, // [checked, reason] if valid
    default: () => [false, '']
  },
  disabled: {
    type: Boolean,
    default: false
  },
  validating: {
    type: Boolean,
    default: false
  },
  readonly: {
    type: Boolean,
    default: false
  },
  error: {
    type: String,
    default: null
  },
  media: {
    type: Object,
    default: () => ({})
  }
},
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const checkbox = ref(null);

const reason = ref('');
const validatedReason = ref('');
const displayPdfDocument = ref(false);

const computedModel = computed(() => props.modelValue?.length ? props.modelValue : [false, '']);
const checked = computed<boolean>(() => computedModel.value[0] as boolean);

watch(() => props.validating, (current, old) => {
  if (old && !current) {
    validatedReason.value = reason.value;
  }
});
onMounted(() => {
  if (computedModel.value && computedModel.value[1] && (computedModel.value[1] as string).length) {
    reason.value = computedModel.value[1] as string;
  }
  validatedReason.value = reason.value;
  onChange();
});
const onKeyUp = (event: KeyboardEvent) => {
  if (props.error || !(event.target as HTMLInputElement).value.length) {
    onChange();
  }
};
const onChange = () => {
  const checked = (checkbox.value as HTMLInputElement).checked;
  const value = [checked, checked ? '' : reason.value];
  if (checked) {
    reason.value = '';
  } else if (!reason.value.length) {
    value.push(false);
  }
  emit('update:modelValue', value as [boolean, string]);
  emit('change');
};
const viewMedia = () => {
  displayPdfDocument.value = true;
};
const closeModal = () => {
  displayPdfDocument.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (displayPdfDocument.value)
      ? (_openBlock(), _createBlock(PatientSupportingDocumentModal, {
          key: 0,
          "document-id": __props.media.documentId,
          onClose: closeModal
        }, null, 8, ["document-id"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "space-x-4 flex flex-row items-center cursor-pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$refs.checkbox as HTMLInputElement).click()))
      }, [
        _createElementVNode("input", _mergeProps({
          ref_key: "checkbox",
          ref: checkbox,
          class: ["form-checkbox outline-none", [__props.disabled ? 'cursor-not-allowed' : 'cursor-pointer', __props.checkboxClass]],
          type: "checkbox"
        }, _ctx.$attrs, {
          disabled: __props.disabled || __props.readonly,
          checked: checked.value,
          onChange: onChange,
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }), null, 16, _hoisted_3),
        _createElementVNode("div", {
          class: _normalizeClass(["flex text-lg font-regular", checked.value ? 'text-gray-500' : 'text-gray-900'])
        }, _toDisplayString(__props.label), 3)
      ]),
      (__props.media && __props.media.documentId)
        ? (_openBlock(), _createBlock(_unref(BaseButton), {
            key: 0,
            "right-icon": "arrow-top-right",
            size: "small",
            color: "gray",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (viewMedia()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.media.label), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (__props.error || reason.value.length || (!reason.value.length && validatedReason.value.length))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["p-6 space-y-4 rounded", reason.value.length ? 'bg-gray-200' : 'bg-danger-500'])
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["text-base font-medium leading-tight", reason.value.length ? 'text-gray-900' : 'text-white'])
          }, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(__props.actionMessage), 1)
          ], 2),
          _createVNode(_unref(BaseTextInput), {
            modelValue: reason.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((reason).value = $event)),
            readonly: __props.readonly,
            onBlur: onChange,
            onKeyup: _cache[4] || (_cache[4] = ($event: any) => (onKeyUp($event)))
          }, null, 8, ["modelValue", "readonly"])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})